import { usePut } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateAccountStatusDefinition() {
  const put = usePut(true, "tms");
  const updateAccountStatusDefinition = (id: string, request) =>
    put<{ id: string }>(`${referenceDataBaseUrl}/account-status-definitions/${id}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ id, request }: { id: string; request }) =>
      await updateAccountStatusDefinition(id, request),
  });
}
